<template>
    <div class="cookie-alert row justify-center" v-if="show">
        <div class="col-smd-10 col-md-8 col-lg-6 gdpr q-pa-md bg-white">

                <p><i aria-hidden="true" class="q-icon material-icons" style="font-size: 2rem; color: rgb(242, 154, 56);">info</i>&nbsp; {{ $t('We use cookies (and other similar technologies) on this site. These are strictly necessary to deliver the site, or features of it that you have selected, in a convenient way.') }}</p>
                <div class="row text-right">
                    <div class="col q-gutter-md">
                       <!-- <v-button :label="$t('More Information')" outline size="md" @click="showMore = true" /> -->
                        <v-button class="bg-green text-white" :label="$t('ok')" outline size="md" @click="save" />

                    </div>
                </div>
        </div>
        <!--<q-modal v-model="showMore" :content-css="{minWidth: '50vw', minHeight: '50vh'}">
            <q-modal-layout>
                <div>
                    <v-header
                            :title="$T('more infomation')"
                            icon="security">
                    </v-header>
                    <card width="100%" style="width: 40vw!important;">
                        <div class="row items-center justify-center">
                           more info

                        </div>
                    </card>
                </div>
                    <q-toolbar color="white"  slot="footer">
                    <div class="row">
                        <div class="col q-gutter-md" slot="footer">
                            <v-button :label="$t('Close')" outline size="md" v-close-overlay />
                            <v-button :label="$t('ok')" outline size="md" @click="save" />

                        </div>
                    </div>
                    </q-toolbar>

            </q-modal-layout>
        </q-modal> -->
    </div>
</template>
<script>
import VButton from './form/VButton'
import {QModalLayout} from 'quasar-framework'
import VHeader from "./Header";
export default {
    components: {VButton, QModalLayout, VHeader},
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            showMore: false
        }
    },

    methods: {
        save () {
            this.$emit('save')
        }
    }
}
</script>
<style lang="stylus" scoped>
.cookie-alert
    font-family: "Noto Sans",sans-serif!important;
    //color white
    z-index 9999
    position fixed
    bottom 15px
    width 100%
.gdpr
    border 1px solid rgb(242,154,56)
    font-size 9pt
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/CookieAlert.vue